/* Custom interactions only. Shopify and GoKwik retain ecommerce-event ownership. */
(function connectKehwahAnalytics(window, document) {
  const measurementId = 'G-BVK7L9H78X';
  const names = new Set(['navigation_open', 'compare_filter', 'faq_open', 'upcoming_notify_intent', 'checkout_intent', 'newsletter_signup_intent', 'testimonial_start', 'testimonial_complete', 'story_audio_start', 'story_audio_complete', 'variant_select', 'product_impression', 'cta_select', 'finder_complete', 'finder_select', 'search_submit', 'search_result_select', 'search_no_results', 'native_form_success', 'whatsapp_draft_open', 'email_draft_open', 'further_reading_open', 'cart_error', 'checkout_handoff_error']);
  const families = new Set(['all', 'tea', 'heritage', 'wellness', 'everyday', 'instant', 'gifts', 'coming-soon']);
  const pages = new Set(['community', 'compare', 'contact', 'faq', 'our-house', 'start-here', 'tea-and-ritual', 'service', 'stories', 'privacy-policy', 'terms-of-service']);
  let handles = [];
  try { handles = JSON.parse(document.querySelector('[data-ks-catalogue-handles]')?.textContent || '[]'); } catch (_) {}
  const products = new Set(Array.isArray(handles) ? handles.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)) : []);
  const debug = new URLSearchParams(window.location.search).get('kehwah_qa') === '1';
  let initialized = false;
  let tag;
  const ownCommands = new Set();
  const allowed = () => !window.Shopify?.designMode && window.Shopify?.theme?.role === 'main' && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function path(value) {
    if (['/', '/search', '/cart', '/other', '/blogs/articles', '/blogs/stories'].includes(value)) return value;
    const parts = typeof value === 'string' ? value.split('/').filter(Boolean) : [];
    if (parts.length === 2 && ((parts[0] === 'products' && products.has(parts[1])) || (parts[0] === 'collections' && families.has(parts[1])) || (parts[0] === 'pages' && pages.has(parts[1])))) return '/' + parts.join('/');
    return '/other';
  }
  function start(pagePath) {
    if (!allowed()) return false;
    window['ga-disable-' + measurementId] = false;
    if (initialized) return true;
    // Google registers each measurement ID once. Reuse its existing queue;
    // only the explicit custom-event allowlist below is forwarded by this bridge.
    if (window.dataLayer !== undefined && !Array.isArray(window.dataLayer)) return false;
    window.dataLayer = window.dataLayer || [];
    tag = function () { ownCommands.add(arguments); window.dataLayer.push(arguments); };
    if (!window.google_tag_manager?.[measurementId]) {
      tag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      tag('js', new Date());
      tag('config', measurementId, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false, page_location: window.location.origin + pagePath, page_referrer: '', page_title: 'Kehwah' });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
      document.head.appendChild(script);
    }
    initialized = true;
    return true;
  }
  window.addEventListener('kehwah:analytics', event => {
    try {
      const input = event.detail;
      if (!input || !names.has(input.event) || !allowed()) return;
      const pagePath = path(input.page_path);
      if (!start(pagePath)) return;
      const parameters = { send_to: measurementId, event_origin: 'kehwah_theme', page_path: pagePath, page_location: window.location.origin + pagePath, page_referrer: '', page_title: 'Kehwah', allow_google_signals: false, allow_ad_personalization_signals: false };
      if (products.has(input.item_id)) parameters.product_handle = input.item_id;
      if (['mobile', 'shop', 'search'].includes(input.navigation_name)) parameters.navigation_name = input.navigation_name;
      if (families.has(input.filter_name) || ['any', 'none', 'low', 'medium'].includes(input.filter_name)) parameters.filter_name = input.filter_name;
      if (['whatsapp', 'email'].includes(input.channel)) parameters.contact_channel = input.channel;
      if (Number.isInteger(input.visible_items) && input.visible_items >= 0 && input.visible_items <= products.size) parameters.visible_items = input.visible_items;
      if (debug) { parameters.debug_mode = true; parameters.traffic_type = 'developer'; }
      tag('event', input.event, parameters);
    } catch (_) { /* Optional measurement cannot interrupt shopping. */ }
  });
  document.addEventListener('visitorConsentCollected', () => {
    try {
      if (!initialized) return;
      const permission = allowed();
      window['ga-disable-' + measurementId] = !permission;
      if (!permission) {
        // Remove only this bridge's queued commands. Other integrations own theirs.
        for (let i = window.dataLayer.length - 1; i >= 0; i--) if (ownCommands.has(window.dataLayer[i])) window.dataLayer.splice(i, 1);
        ownCommands.clear();
      }
      tag('consent', 'update', { analytics_storage: permission ? 'granted' : 'denied' });
    } catch (_) {}
  });
})(window, document);
